import ComingSoon from "components/ComingSoon";
import withAsync from "components/withAsync";
import useLDFlag from "hooks/useLDFlag";

import { useGetBrokerReportTypeListQuery } from "./api/brokerInsightsApi";
import BrokerInsightsFilterBarContainer from "./containers/BrokerInsightsFilterBarContainer";
import BrokerInsightsIndexTableContainer from "./containers/BrokerInsightsIndexTableContainer";
import { useBrokerInsightsIndexSlices } from "./store/brokerInsightsIndexStore";

const BrokerInsightsIndexPage = withAsync({
  useHook: () => {
    useBrokerInsightsIndexSlices();

    return useGetBrokerReportTypeListQuery({});
  },
  Component: () => {
    const enableBrokerReports = useLDFlag("enableBrokerReports");

    if (!enableBrokerReports) {
      return <ComingSoon />;
    }

    return (
      <>
        <BrokerInsightsFilterBarContainer />
        <BrokerInsightsIndexTableContainer />
      </>
    );
  },
});

export default BrokerInsightsIndexPage;
